import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { DatePicker, FF2, Info, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const TransStartDate = () => {
  const { control } = useFormContext<SarEdit>()

  const id = useWatch({ control, name: 'id' })

  return (
    <Controller
      name="generalInfo.transactionStartDate"
      control={control}
      rules={{ validate: Validators.required.field }}
      render={({ field }) =>
        id ? (
          <Info label="Transactions Start Date">{field.value}</Info>
        ) : (
          <FF2
            required
            field={field}
            label="Transactions Start Date"
            input={(props) => <DatePicker {...props} data-qa="General. Transactions Start Date" />}
          />
        )
      }
    />
  )
}
